<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.bargains'), $t('text.create')]"
      ></breadcrumb>
      <el-form ref="rentForm" :model="rent" size="small" label-width="90px">
        <div class="container pd20">
          <div v-if="rentPackage != null" class="center font18">
            {{ rentPackage.name }}：{{ rent.amount }}
            <i class="el-icon-edit" @click="editRentPrice"></i>
          </div>
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="7">
                <el-form-item
                  :label="$t('rent.serialNo')"
                  :prop="'serialNo'"
                  :rules="[
                    {
                      required: true,
                      validator: validateSerialNo,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="rent.serialNo"
                    :placeholder="$t('prompt.alphabetNumberLine')"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item
                  :label="$t('rent.rentAt')"
                  :prop="'_rentAt'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('rent.rentAt')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-date-picker
                    size="small"
                    v-model="rent._rentAt"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="-"
                    :start-placeholder="
                      $t('rules.startAt', [$t('rent.rentAt')])
                    "
                    :end-placeholder="$t('rules.endAt', [$t('rent.rentAt')])"
                  />
                  <!-- :picker-options="pickerOptions" -->
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('menu.shops')"
                  :prop="'shopId'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('menu.shops')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    size="small"
                    v-model="rent.shopId"
                    filterable
                    :disabled="Permit.createOrderFixShopDF()"
                  >
                    <el-option
                      v-for="shop in shops"
                      :key="shop.id"
                      :label="shop.name"
                      :value="shop.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item
                  :label="$t('text.ownerName')"
                  :prop="'ownerId'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('text.ownerName')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    size="small"
                    v-model="rent.ownerId"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="user in users"
                      :key="user.id"
                      :label="user.name"
                      :value="user.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>
              {{ $t("customer.customerInfo") }}
              <el-checkbox v-model="showAddressInfoDF" class="float-right">
                填地址
              </el-checkbox>
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('customer.phone')"
                  :prop="'customerPhone'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('customer.phone')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-autocomplete
                    size="small"
                    v-model.trim="rent.customerPhone"
                    :fetch-suggestions="querySearchCustomerPhone"
                    :trigger-on-focus="false"
                    style="width: 100%"
                    @select="handleSelectCustomerPhone"
                    :placeholder="$t('customer.phoneName')"
                  >
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.phone }}</div>
                      <span class="addr"
                        >{{ item.name }}-{{ item.company }}</span
                      >
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('customer.name')"
                  :prop="'customerName'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('customer.name')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="rent.customerName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('customer.source')">
                  <el-select
                    size="small"
                    v-model="rent.customerSource"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="source in sources"
                      :key="source.id"
                      :label="source.name"
                      :value="source.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('customer.sourceRemark')">
                  <el-autocomplete
                    size="small"
                    v-model="rent.customerSourceRemark"
                    :fetch-suggestions="querySearchSourceRemarks"
                    style="width: 100%"
                    @select="handleSelectSourceRemarks"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('customer.suggestName')"
                  :prop="'suggestName'"
                >
                  <el-select
                    size="small"
                    v-model.trim="rent.customerSuggestId"
                    filterable
                    remote
                    clearable
                    :loading="customersLoading"
                    :placeholder="$t('customer.phoneName')"
                    :remote-method="querySearchCustomerSuggest"
                    @change="handleSelectCustomerSuggest"
                  >
                    <el-option
                      v-for="customer in customers"
                      :key="customer.id"
                      :label="customer.name + '(' + customer.phone + ')'"
                      :value="customer.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="showAddressInfoDF">
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('tenant.province')"
                    :prop="'province'"
                  >
                    <el-input
                      size="small"
                      v-model.trim="rent.customerProvince"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('tenant.city')" :prop="'city'">
                    <el-input
                      size="small"
                      v-model.trim="rent.customerCity"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="$t('tenant.address')" :prop="'address'">
                    <el-input
                      size="small"
                      v-model.trim="rent.customerAddress"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </fieldset>
        </div>
        <div
          v-if="
            rentPackage &&
            rentPackage.configs &&
            rentPackage.configs.length != 0
          "
        >
          <el-row :gutter="20">
            <el-col :span="16">
              <div class="container pd20">
                <div
                  v-for="(config, configIndex) of rentPackage.configs"
                  :key="configIndex"
                  class="mgb20"
                >
                  <fieldset class="mgb15">
                    <legend>
                      可选{{ config.categoryName }}
                      <el-button
                        size="mini"
                        type="success"
                        plain
                        class="float-right"
                        style="padding: 5px 10px"
                        @click="addConfigItem(config, configIndex)"
                      >
                        套餐外{{ config.categoryName }}
                      </el-button>
                    </legend>
                    <el-row :gutter="10" class="mgb5">
                      <el-col
                        :span="4"
                        v-for="(
                          configItem, configItemIndex
                        ) of config.configItems"
                        :key="configItemIndex"
                      >
                        <div class="config-item-image">
                          <thumbnail
                            v-if="configItem.product"
                            :images="configItem.product.images"
                            width="auto"
                            height="100%"
                          />
                        </div>
                        <div class="center">
                          <div class="font10">
                            <raw-html-limit-number
                              v-if="configItem.product == null"
                              :content="configItem.productNo"
                              :number="6"
                            />
                            <el-popover
                              v-else
                              placement="right"
                              width="200"
                              trigger="click"
                            >
                              <template>
                                <div class="lineH24">
                                  {{ $t("product.productNo") }}：{{
                                    configItem.product.productNo
                                  }}
                                </div>
                                <div class="lineH24">
                                  {{ $t("product.color") }}：{{
                                    configItem.product.colors.join("，")
                                  }}
                                </div>
                                <div class="lineH24">
                                  {{ $t("product.size") }}：{{
                                    configItem.product.sizes.join("，")
                                  }}
                                </div>
                                <div class="lineH24">
                                  {{ $t("product.salesPrice") }}：{{
                                    configItem.product.salesPrice | currency
                                  }}
                                </div>
                                <div class="lineH24">
                                  {{ $t("product.rentPrice") }}：{{
                                    configItem.product.rentPrice | currency
                                  }}
                                </div>
                              </template>
                              <span
                                slot="reference"
                                class="overflow a popover-reference"
                              >
                                {{ configItem.product.productNo }}
                              </span>
                            </el-popover>
                          </div>
                          <div
                            v-if="configItem.product"
                            class="overflow center red font8"
                          >
                            {{ configItem.product.rentPrice | currency }}
                          </div>
                          <div class="center">
                            <el-button
                              type="primary"
                              size="mini"
                              style="padding: 3px 30px"
                              @click="selectConfigItem(config, configItem)"
                            >
                              {{ $t("action.select") }}
                            </el-button>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </fieldset>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="container pd20">
                <div
                  v-for="(
                    selectedConfig, selectedConfigIndex
                  ) of selectedConfigs"
                  :key="selectedConfigIndex"
                  class="mgb20"
                >
                  <fieldset class="mgb15">
                    <legend>
                      {{ selectedConfig.categoryName }}&nbsp;{{
                        selectedConfig.quantity
                      }}&nbsp;{{ selectedConfig.unit }}
                    </legend>
                    <div v-if="selectedConfig.selectedConfigItems.length == 0">
                      <div
                        style="
                          font-size: 20px;
                          color: rgb(233, 231, 231);
                          border: 0;
                          line-height: 120px;
                        "
                        class="config-item-image center"
                      >
                        待选
                      </div>
                    </div>
                    <el-row v-else :gutter="10" class="mgb5">
                      <el-col
                        :span="8"
                        v-for="(
                          selectedConfigItem, selectedConfigItemIndex
                        ) of selectedConfig.selectedConfigItems"
                        :key="selectedConfigItemIndex"
                      >
                        <div class="config-item-image">
                          <div
                            style="position: absolute; width: 16%; z-index: 2"
                          >
                            <i
                              class="el-icon-circle-close red"
                              @click="
                                removeSelectedConfigItem(
                                  selectedConfigIndex,
                                  selectedConfigItemIndex
                                )
                              "
                            ></i>
                          </div>
                          <thumbnail
                            v-if="selectedConfigItem.product"
                            :images="selectedConfigItem.product.images"
                            width="auto"
                            height="100%"
                          />
                        </div>
                        <div class="center">
                          <div class="font10">
                            <raw-html-limit-number
                              :content="selectedConfigItem.productNo"
                              :number="8"
                            />
                          </div>
                          <div>
                            <raw-html-limit-number
                              v-if="selectedConfigItem.color"
                              :content="selectedConfigItem.color"
                              :number="4"
                              class="mgr5"
                            />
                            <raw-html-limit-number
                              v-if="selectedConfigItem.size"
                              :content="selectedConfigItem.size"
                              :number="3"
                            />
                          </div>
                          <div class="overflow center font8">
                            <span class="mgr5">
                              {{ selectedConfigItem.quantity
                              }}{{ selectedConfig.unit }}
                            </span>
                            <span v-if="selectedConfigItem.product" class="red">
                              {{
                                selectedConfigItem.product.rentPrice | currency
                              }}
                            </span>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </fieldset>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="container pd20">
          <fieldset class="mgb15">
            <legend>
              {{ $t("rent.receivePaymentInfo") }}
              <el-checkbox
                v-model="showDepositInfoDF"
                class="float-right"
                @change="clickShowDepositInfo"
              >
                {{ $t("rent.deposit") }}
              </el-checkbox>
            </legend>
            <el-row>
              <el-col :span="16">
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('payment.total')"
                      :prop="'_paymentTotal'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [$t('payment.total')]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input v-model="rent._paymentTotal"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('payment.payMethod')"
                      :prop="'_paymentPayMethodId'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('payment.payMethod'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-select v-model="rent._paymentPayMethodId">
                        <el-option
                          v-for="payMethod in payMethods"
                          :key="payMethod.id"
                          :label="payMethod.name"
                          :value="payMethod.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('payment.paidAt')"
                      :prop="'_paymentPaidAt'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [$t('payment.paidAt')]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-date-picker
                        size="small"
                        v-model="rent._paymentPaidAt"
                        type="date"
                        style="width: 100%"
                        :picker-options="pickerOptionsFiveDays"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('payment.explain')"
                      :prop="'_paymentExplain'"
                    >
                      <el-input v-model="rent._paymentExplain"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('payment.voucher')"
                  :prop="'_paymentVoucher'"
                >
                  <upload-single-picture v-model="rent._paymentVoucher" />
                </el-form-item>
              </el-col>
            </el-row>
            <div
              v-if="showDepositInfoDF"
              style="border-bottom: 1px dashed rgba(0, 0, 0, 0.05)"
              class="mgb10"
            ></div>
            <el-row v-if="showDepositInfoDF">
              <el-col :span="16">
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('deposit.total')"
                      :prop="'deposit.total'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [$t('deposit.total')]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input v-model="rent.deposit.total"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('deposit.payMethod')"
                      :prop="'deposit.payMethodId'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('deposit.payMethod'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-select v-model="rent.deposit.payMethodId">
                        <el-option
                          v-for="payMethod in payMethods"
                          :key="payMethod.id"
                          :label="payMethod.name"
                          :value="payMethod.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('deposit.paidAt')"
                      :prop="'deposit.paidAt'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [$t('deposit.paidAt')]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-date-picker
                        size="small"
                        v-model="rent.deposit.paidAt"
                        type="date"
                        style="width: 100%"
                        :picker-options="pickerOptionsFiveDays"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('deposit.remark')"
                      :prop="'deposit.remark'"
                    >
                      <el-input v-model="rent.deposit.remark"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$t('deposit.voucher')"
                  :prop="'_paymentVoucher'"
                >
                  <upload-single-picture v-model="rent._depositVoucher" />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </div>
        <div class="container pd20">
          <fieldset class="mgb15">
            <legend>{{ $t("text.remark") }}</legend>
            <el-input
              v-model="rent.remark"
              type="textarea"
              :rows="2"
            ></el-input>
          </fieldset>
        </div>
        <div class="form-footer">
          <el-button
            type="primary"
            size="medium"
            plain
            :loading="saveDoing"
            @click="saveSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <back-button />
        </div>
      </el-form>
    </div>
    <!-- 选择 -->
    <el-dialog
      :title="$t('action.select')"
      :close-on-click-modal="false"
      :visible.sync="selectDF"
      width="30%"
    >
      <el-form ref="selectObjForm" :model="selectObj" label-width="60px">
        <el-form-item :label="$t('product.color')" :prop="'color'">
          <el-autocomplete
            size="small"
            v-model.trim="selectObj.color"
            :fetch-suggestions="querySearchColor"
            :placeholder="$t('product.color')"
            style="width: 100%"
            @select="handleSelectColor"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item :label="$t('product.size')" :prop="'size'">
          <el-autocomplete
            size="small"
            v-model.trim="selectObj.size"
            :fetch-suggestions="querySearchSize"
            :placeholder="$t('product.size')"
            style="width: 100%"
            @select="handleSelectSize"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="selectObj.quantity"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="selectSubmitDoing"
          size="small"
          @click="selectConfigItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="selectDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑金额 -->
    <el-dialog
      :title="$t('rules.edit', [$t('text.amount')])"
      :close-on-click-modal="false"
      :visible.sync="editRentPriceDF"
      width="30%"
    >
      <el-form ref="editRentPriceObjForm" :model="editRentPriceObj">
        <el-form-item
          :prop="'amount'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.amount')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editRentPriceObj.amount"
            :placeholder="$t('text.amount')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRentPriceSubmitDoing"
          size="small"
          @click="editRentPriceSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRentPriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 套餐外产品 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('menu.products')"
      :close-on-click-modal="false"
      :visible.sync="addConfigItemDF"
      width="80%"
    >
      <div>
        <el-form
          :inline="true"
          @submit.native.prevent="changeSearch"
          :model="productSearch"
          size="small"
        >
          <el-form-item>
            <el-input
              size="small"
              v-model.trim="productSearch.productNo"
              :placeholder="$t('product.productNo')"
            />
          </el-form-item>
          <el-form-item>
            <el-select
              size="small"
              :placeholder="$t('menu.brands')"
              v-model="productSearch.brandId"
              clearable
              filterable
            >
              <el-option
                v-for="brand in brands"
                :key="brand.id"
                :label="brand.name"
                :value="brand.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              native-type="submit"
            />
          </el-form-item>
        </el-form>
      </div>
      <div v-if="records && records.length != 0">
        <el-checkbox v-model="checkAllDF" value="1" @change="checkAll">{{
          $t("action.checkAll")
        }}</el-checkbox>
        <el-row :gutter="5">
          <el-col v-for="row in records" :key="row.id" :span="4" class="mgt10">
            <el-card :body-style="{ padding: '0px' }">
              <div style="height: 240px">
                <div class="image-div">
                  <div class="product-checkbox-div" style="z-index: 2">
                    <input
                      :disabled="addedProductDF(row.id)"
                      v-model="checkedProducts"
                      type="checkbox"
                      :value="row"
                      class="float-right"
                      @change="checkedProduct"
                    />
                  </div>
                  <div
                    v-if="addedProductDF(row.id) == true"
                    class="product-label-div red font8"
                    style="z-index: 2"
                  >
                    已添加
                  </div>
                  <thumbnail :images="row.images" width="auto" height="100%" />
                </div>
                <div class="pd5">
                  <el-row class="mgb5">
                    <el-col :span="16" class="overflow">
                      <el-popover placement="right" width="200" trigger="click">
                        <template>
                          <div class="lineH24">
                            {{ $t("product.productNo") }}：{{ row.productNo }}
                          </div>
                          <div class="lineH24">
                            {{ $t("product.color") }}：{{
                              row.colors.join("，")
                            }}
                          </div>
                          <div class="lineH24">
                            {{ $t("product.size") }}：{{ row.sizes.join("，") }}
                          </div>
                          <div class="lineH24">
                            {{ $t("product.salesPrice") }}：{{
                              row.salesPrice | currency
                            }}
                          </div>
                          <div class="lineH24">
                            {{ $t("product.rentPrice") }}：{{
                              row.rentPrice | currency
                            }}
                          </div>
                        </template>
                        <span slot="reference" class="a popover-reference">{{
                          row.productNo
                        }}</span>
                      </el-popover>
                    </el-col>
                    <el-col :span="8" class="overflow right red">
                      {{ row.rentPrice | currency }}
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div v-else class="noData">{{ $t("text.noData") }}</div>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="productSearch.currentPage"
            :page-size="productSearch.pageSize"
            :total="total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addConfigItemSubmitDoing"
          size="small"
          @click="addConfigItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addConfigItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";

import PagerConfig from "@/config/pager.js";

import BackButton from "@/components/BackButton";
import Thumbnail from "@/components/Thumbnail";
import UploadSinglePicture from "@/components/UploadSinglePicture";
import Dropzone from "@/components/Dropzone";
import Shop from "@/api/shop.js";
import User from "@/api/user.js";

import PayMethod from "@/api/payMethod.js";
import Rent from "@/api/rent.js";
import Customer from "@/api/customer.js";
import RentPackage from "@/api/rentPackage.js";
import Brand from "@/api/brand.js";
import Product from "@/api/product.js";
import Source from "@/api/source.js";
import Color from "@/api/color.js";
import Size from "@/api/size.js";
import Schedule from "@/api/schedule.js";

function bulid() {
  return {
    type: "rent",
    serialNo: null,
    quantity: null,
    productNo: null,
    color: null,
    size: null,
    unit: null,
    price: null,
    images: null,
    categoryId: null,
    categoryName: null,
    brandId: null,
    brand: null,
    remark: null,
  };
}
export default {
  mixins: [page],
  components: { BackButton, Thumbnail, UploadSinglePicture, Dropzone },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value.trim() === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("bargain.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      Rent.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("rent.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      validateSerialNo: validateSerialNo,
      Util: Util,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pickerOptionsFiveDays: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const day = 5 * 24 * 3600 * 1000;
          const threeMonths = curDate - day;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
      },
      shops: [],
      users: [],
      payMethods: [],
      sources: [],
      schedule: null,
      rent: {
        serialNo: Util.serialNo(),
        startAt: null,
        endAt: null,
        shopId: null,
        shopName: null,
        ownerId: null,
        ownerName: null,

        amount: null,
        packageId: null,
        scheduleId: null,
        type: "rent",
        customerId: null,
        customerPhone: null,
        customerName: null,
        customerProvince: null,
        customerCity: null,
        customerAddress: null,
        customerSource: null,
        customerSourceRemark: null,
        customerSuggestId: null,
        remark: null,
        items: [],
        payments: [],
        _rentAt: null,
        _paymentTotal: null,
        _paymetPayMethodId: null,
        _paymentExplain: null,
        _paymentVoucher: null,
        _paymentPaidAt: new Date(),
        deposit: {
          total: null,
          payMethodId: null,
          payMethodName: null,
          remark: null,
          voucher: null,
        },
      },
      customersLoading: false,

      showAddressInfoDF: false,
      showDepositInfoDF: false,
      customers: [],
      payMethods: [],
      rentPackage: null,
      selectedConfigs: [],
      saveDoing: false,
      //选择
      selectDF: false,
      selectObj: {
        color: null,
        size: null,
        quantity: null,
      },
      selectConfigObj: null,
      selectConfigItemObj: null,
      categories: [],
      productColors: [],
      productSizes: [],
      selectSubmitDoing: false,
      //
      editRentPriceDF: false,
      editRentPriceObj: {
        amount: null,
      },
      editRentPriceSubmitDoing: false,
      //新增类别项
      configIndex: null,
      configItempProductIds: [],
      pagerConfig: PagerConfig.product,
      addConfigItemDF: false,
      brands: [],
      productSearch: {
        currentPage: 1,
        pageSize: 30,
        sortBy: "product_id",
        sortIndicator: "desc",
        categoryId: null,
        brandId: null,
      },
      addConfigItemSubmitDoing: false,
      records: [],
      total: 0,
      selectRecordQty: 0,
      checkedProducts: [],
      checkAllDF: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.rent.ownerId = self.Permit.currentUser().id;
    self.rent.shopId = self.Permit.currentUser()._shopId;

    self.rent.packageId = self.$route.params.rentPackageId;
    if (self.$route.query != undefined && self.$route.query != null) {
      self.rent.customerId = self.$route.query.customerId;
      self.rent.scheduleId = self.$route.query.scheduleId;
      if (self.rent.customerId != null) {
        self.getCustomer();
      }
      if (self.rent.scheduleId != null) {
        self.getSchedule();
      }
    }
    axios
      .all([
        Shop.findByTenantId(),
        User.findByTenantId(),
        PayMethod.findByTenantId(),
        RentPackage.findById(self.$route.params.rentPackageId),
        Source.findByTenantId(),
        Color.findByTenantId(),
        Size.findByTenantId(),
      ])
      .then(
        axios.spread(function (
          shops,
          users,
          payMethods,
          rentPackage,
          sources,
          colors,
          sizes
        ) {
          if (shops.status === 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
          if (users.status == 200) {
            const allUsers = users.data.filter(
              (u) =>
                (u.voidAt == null && u.authorizeW == true) || u.voidAt != null
            );
            if (self.Permit.currentUser().admin === true) {
              self.users = allUsers;
            } else {
              self.users = allUsers.filter((u) =>
                JSON.parse(self.Permit.currentUser()._manageUsers).includes(
                  u.id
                )
              );
            }
          } else {
            self.sysError();
          }

          if (payMethods.status === 200) {
            self.payMethods = payMethods.data;
          } else {
            self.sysError();
          }
          if (rentPackage.data.code === 200) {
            self.rentPackage = rentPackage.data.entity;
            self.selectedConfigs = self.rentPackage.configs.map((r) => {
              return {
                categoryId: r.categoryId,
                categoryName: r.categoryName,
                categoryType: r.categoryType,
                quantity: r.quantity,
                unit: r.unit,
                selectedConfigItems: [],
              };
            });
            self.rent.amount = self.rentPackage.price;
            self.rent._paymentTotal = self.rent.amount;
          } else {
            self.sysError();
          }
          if (sources.status === 200) {
            self.sources = sources.data;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    getCustomer() {
      const self = this;
      Customer.findById(self.rent.customerId).then(function (res) {
        if (res.data.code === 200) {
          const customer = res.data.entity;
          self.rent.customerId = customer.id;
          self.rent.customerName = customer.name;
          self.rent.customerPhone = customer.phone;
          self.rent.customerSource = customer.source;
          self.rent.customerProvince = customer.province;
          self.rent.customerCity = customer.city;
          self.rent.customerAddress = customer.address;
          self.rent.customerSource = customer.source;
          self.rent.customerSourceRemark = customer.sourceRemark;
          self.rent.customerSuggestId = customer.suggestId;
        } else {
          self.sysError();
        }
      });
    },
    getSchedule() {
      const self = this;
      Schedule.findById(self.rent.scheduleId).then(function (res) {
        if (res.data.code === 200) {
          const schedule = res.data.entity;
          self.rent.customerName = schedule.customerName;
          self.rent.customerSource = schedule.source;
          self.rent.customerSourceRemark = schedule.sourceRemark;
        } else {
          self.sysError();
        }
      });
    },
    clickShowDepositInfo() {
      const self = this;
      if (!this.showDepositInfoDF) {
        return;
      }
      self.rent.deposit.payMethodId = self.rent._paymentPayMethodId;
      self.rent.deposit.paidAt = self.rent._paymentPaidAt;
    },
    //添加类别项目============
    addConfigItem(config, configIndex) {
      const self = this;
      self.configIndex = configIndex;
      self.checkedProducts = [];
      self.productSearch.categoryId = config.categoryId;
      self.productSearch.pageSize = 30;
      self.checkAllDF = false;
      self.configItempProductIds = config.configItems.map(
        (configItem) => configItem.productId
      );
      axios
        .all([
          Brand.findByTenantId(),
          Product.search(Util.deleteObjValueIsNull(self.productSearch)),
        ])
        .then(
          axios.spread(function (brands, products) {
            if (brands.status == 200) {
              self.brands = brands.data;
            } else {
              self.sysError();
            }
            if (products.status == 200) {
              self.records = products.data.records;
              self.total = products.data.total;
              if (self.total == 0) {
                self.$message({
                  message: "暂无此类别产品",
                  type: "warning",
                });
                return;
              }
              self.addConfigItemDF = true;
            } else {
              self.sysError();
            }
          })
        );
    },
    addedProductDF(productId) {
      if (this.configItempProductIds.includes(productId)) {
        return true;
      }
      return false;
    },
    loadProduct() {
      const self = this;
      Product.search(Util.deleteObjValueIsNull(self.productSearch)).then(
        function (res) {
          if (res.status == 200) {
            self.records = res.data.records;
            self.total = res.data.total;
          } else {
            self.sysError();
          }
        }
      );
    },
    changePager(params) {
      this.productSearch.currentPage = params.currentPage;
      this.productSearch.pageSize = params.pageSize;
      this.loadProduct();
    },
    changeSearch() {
      this.productSearch.currentPage = 1;
      this.productSearch.pageSize = PagerConfig.product.defaultPageSize;
      this.loadProduct();
    },
    checkedProduct() {
      this.selectRecordQty = this.checkedProducts.length;
    },
    checkAll() {
      if (this.checkAllDF === true) {
        this.checkedProducts = this.records.filter(
          (r) => this.addedProductDF(r.id) == false
        );
      } else {
        this.checkedProducts = [];
      }
      this.selectRecordQty = this.checkedProducts.length;
    },
    addConfigItemSubmit() {
      const self = this;
      if (self.checkedProducts.length == 0) {
        self.$message.error(this.$t("prompt.atLeastSelectOneData"));
        return;
      }
      const checkedProductsFilter = self.checkedProducts.filter(
        (c) => this.addedProductDF(c.id) == false
      );
      if (checkedProductsFilter.length == 0) {
        self.$message({
          message: "至少选择一条该类别里面不存在的产品",
          type: "warning",
        });
        return;
      }
      self.addConfigItemSubmitDoing = true;
      for (const product of checkedProductsFilter) {
        let obj = {
          id: null,
          rentPackageId: null,
          rentPackageConfigId: null,
          productId: product.id,
          productNo: product.productNo,
          tenantId: null,
          product: product,
        };
        self.rentPackage.configs[self.configIndex].configItems.push(obj);
      }
      self.addConfigItemSubmitDoing = false;
      self.addConfigItemDF = false;
    },
    //编辑啊价格
    editRentPrice() {
      const self = this;
      self.editRentPriceObj.amount = self.rent.amount;
      self.editRentPriceSubmitDoing = false;
      self.editRentPriceDF = true;
    },

    editRentPriceSubmit() {
      const self = this;
      this.$refs.editRentPriceObjForm.validate((valid) => {
        if (valid) {
          self.editRentPriceSubmitDoing = true;
          self.rent.amount = self.editRentPriceObj.amount;
          self.rent._paymentTotal = self.rent.amount;
          self.editRentPriceSubmitDoing = false;
          self.editRentPriceDF = false;
        } else {
          return false;
        }
      });
    },
    //
    querySearchCustomerPhone(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.rent.customerId = null;
      if (self.rent.scheduleId == null) {
        self.rent.customerName = null;
        self.rent.customerProvince = null;
        self.rent.customerCity = null;
        self.rent.customerAddress = null;
        self.rent.customerSource = null;
        self.rent.customerSourceRemark = null;
        self.rent.customerSuggestId = null;
      }
      Customer.vagueFind({ keyword: queryString }).then(function (res) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.phone));
        self.customers = ps;
        cb(self.customers);
      });
    },
    handleSelectCustomerPhone() {
      const self = this;
      const item = self.customers.find(
        (p) => p.phone === self.rent.customerPhone
      );
      self.rent.customerId = item.id;
      self.rent.customerName = item.name;
      self.rent.customerPhone = item.phone;
      self.rent.customerProvince = item.province;
      self.rent.customerCity = item.city;
      self.rent.customerAddress = item.address;
      self.rent.customerSource = item.source;
      self.rent.customerSourceRemark = item.sourceRemark;
      self.rent.customerSuggestId = item.suggestId;
    },

    // 具体来源
    querySearchSourceRemarks(queryString, cb) {
      Customer.sourceRemarks().then(function (res) {
        const sourceRemarks = res.data.map((item) => {
          return { value: item };
        });
        cb(sourceRemarks);
      });
    },
    handleSelectSourceRemarks(item) {},
    querySearchCustomerSuggest(queryString, cb) {
      const self = this;
      self.rent.customerSuggestId = null;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.customersLoading = true;
      Customer.vagueFind({ keyword: queryString }).then(function (res) {
        self.customers = res.data;
        self.customersLoading = false;
      });
    },
    handleSelectCustomerSuggest() {
      const self = this;
    },
    //选择产品
    selectConfigItem(config, configItem) {
      const self = this;
      self.selectConfigObj = config;
      self.selectConfigItemObj = configItem;
      self.selectObj.color = null;
      self.selectObj.size = null;
      self.selectObj.quantity = 1;
      self.selectSubmitDoing = false;
      if (config.categoryType == "product") {
        if (configItem.product != null) {
          self.productColors = configItem.product.colors;
          self.productSizes = configItem.product.sizes;
          self.selectObj.color =
            self.productColors.length == 1 ? self.productColors[0] : null;
          self.selectObj.size =
            self.productSizes.length == 1 ? self.productSizes[0] : null;
        }
        self.selectDF = true;
      } else {
        let index = self.selectedConfigs.findIndex(
          (c) => c.categoryId == self.selectConfigObj.categoryId
        );
        let existObj = self.selectedConfigs[index].selectedConfigItems.find(
          (i) => i.productNo == self.selectConfigItemObj.productNo
        );
        if (existObj != null) {
          self.$message({
            message: self.$t("rules.exist", [self.$t("menu.services")]),
            type: "warning",
          });
          return;
        }
        let selectedConfigItemObj = JSON.parse(
          JSON.stringify(self.selectConfigItemObj)
        );
        Vue.set(selectedConfigItemObj, "color", null);
        Vue.set(selectedConfigItemObj, "size", null);
        Vue.set(selectedConfigItemObj, "quantity", 1);
        Vue.set(selectedConfigItemObj, "type", "service");
        self.selectedConfigs[index].selectedConfigItems.push(
          selectedConfigItemObj
        );
      }
    },
    // 颜色
    querySearchColor(queryString, cb) {
      const self = this;
      const colors =
        self.productColors !== 0
          ? self.productColors.map((pc) => {
              return { value: pc };
            })
          : self.colors.map((c) => {
              return { value: c.name };
            });

      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor(idx) {},
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      const sizes =
        self.productSizes.length !== 0
          ? self.productSizes.map((pc) => {
              return { value: pc };
            })
          : this.sizes.map((c) => {
              return { value: c.name };
            });

      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize(idx) {
      const self = this;
    },
    selectConfigItemSubmit() {
      const self = this;
      this.$refs.selectObjForm.validate((valid) => {
        if (valid) {
          //
          let index = self.selectedConfigs.findIndex(
            (c) => c.categoryId == self.selectConfigObj.categoryId
          );
          let existObj = self.selectedConfigs[index].selectedConfigItems.find(
            (i) =>
              i.productNo == self.selectConfigItemObj.productNo &&
              i.color == self.selectObj.color &&
              i.size == self.selectObj.size
          );
          if (existObj != null) {
            self.$message({
              message: self.$t("rules.exist", [self.$t("menu.products")]),
              type: "warning",
            });
            return;
          }
          if (!Util.regexQuantity(self.selectObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }

          self.selectSubmitDoing = true;
          let selectedConfigItemObj = JSON.parse(
            JSON.stringify(self.selectConfigItemObj)
          );
          Vue.set(selectedConfigItemObj, "color", self.selectObj.color);
          Vue.set(selectedConfigItemObj, "size", self.selectObj.size);
          Vue.set(selectedConfigItemObj, "quantity", self.selectObj.quantity);
          Vue.set(selectedConfigItemObj, "type", "rent");
          self.selectedConfigs[index].selectedConfigItems.push(
            selectedConfigItemObj
          );
          self.selectSubmitDoing = false;
          self.selectDF = false;
        }
      });
    },
    removeSelectedConfigItem(selectedConfigIndex, selectedConfigItemIndex) {
      this.selectedConfigs[selectedConfigIndex].selectedConfigItems.splice(
        selectedConfigItemIndex,
        1
      );
    },
    //===
    saveSubmit() {
      const self = this;
      this.$refs.rentForm.validate((valid) => {
        if (valid) {
          let selectedConfigsNew = JSON.parse(
            JSON.stringify(this.selectedConfigs)
          );
          const selectedConfigsNewFilter = selectedConfigsNew.filter(
            (s) => s.selectedConfigItems.length !== 0
          );
          if (selectedConfigsNewFilter.length === 0) {
            self.$message.error(this.$t("prompt.atLeastAddOneProduct"));

            return;
          }
          User.findByPhone({ phone: self.rent.customerPhone }).then(function (
            res
          ) {
            if (
              res.data.code === 200 &&
              res.data.entity.tenantId === self.Permit.currentTenant().id
            ) {
              self.$message.error(self.$t("prompt.notAddOneself"));
            } else {
              self.rent.items = [];
              for (const selectedConfig of selectedConfigsNewFilter) {
                let quantityTotal = 0;
                for (const item of selectedConfig.selectedConfigItems) {
                  quantityTotal = quantityTotal + item.quantity;
                }
                if (quantityTotal > selectedConfig.quantity) {
                  self.$message({
                    message:
                      "选择的" +
                      selectedConfig.categoryName +
                      "数量大于套餐数量",
                    type: "warning",
                  });
                  return;
                }
                self.rent.items = self.rent.items.concat(
                  selectedConfig.selectedConfigItems.map((i) => {
                    return {
                      type: null,
                      serialNo: null,
                      quantity: i.quantity,
                      productNo: i.productNo,
                      color: Util.jyTrim(i.color),
                      size: Util.jyTrim(i.size),
                      unit: selectedConfig.unit,
                      price: i.product != null ? i.product.rentPrice : null,
                      images: i.product != null ? i.product.images : null,
                      categoryId: selectedConfig.categoryId,
                      categoryName: selectedConfig.categoryName,
                      brandId: i.product != null ? i.product.brandId : null,
                      brand: i.product != null ? i.product.brandName : null,
                      remark: null,
                      type: i.type,
                    };
                  })
                );
              }
              //
              if (!Util.regexQuantity(self.rent._paymentTotal)) {
                self.$message({
                  message: self.$t("rules.regex", [self.$t("payment.total")]),
                  type: "warning",
                });
                return;
              }
              var newPaymentObj = {
                total: self.rent._paymentTotal,
                payMethodId: self.rent._paymentPayMethodId,
                payMethodName: self.payMethods.find(
                  (p) => p.id === self.rent._paymentPayMethodId
                ).name,
                paidAt: Util.formatDate(self.rent._paymentPaidAt),
                explain: self.rent._paymentExplain,
                voucher: self.rent._paymentVoucher,
              };
              self.rent.payments = [newPaymentObj];
              if (self.showDepositInfoDF) {
                self.rent.deposit.payMethodName = self.payMethods.find(
                  (p) => p.id === self.rent.deposit.payMethodId
                ).name;
              } else {
                self.rent.deposit = null;
              }
              //
              self.rent.startAt = Util.formatDate(self.rent._rentAt[0]);
              self.rent.endAt = Util.formatDate(self.rent._rentAt[1]);
              self.rent.shopName = self.shops.find(
                (s) => s.id === self.rent.shopId
              ).name;
              self.rent.ownerName = self.users.find(
                (u) => u.id === self.rent.ownerId
              ).name;

              if (self.rent.items.length === 1) {
                self.rent.items[0].serialNo = self.rent.serialNo;
              }
              for (const o of self.rent.items) {
                o.startAt = Util.formatDate(self.rent._rentAt[0]);
                o.endAt = Util.formatDate(self.rent._rentAt[1]);
              }
              // console.log("========", self.rent);
              self.saveDoing = true;
              Rent.create(self.rent).then(function (res) {
                self.saveDoing = false;
                if (res.status === 200) {
                  self.$message({
                    message: self.$t("prompt.addSuccess"),
                    type: "success",
                  });
                  self.$router.push({ name: "rents" });
                } else {
                  self.sysError();
                }
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>


<style scoped>
.config-item-image {
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  height: 120px;
  margin-bottom: 5px;
  /* border-radius: 5px; */
}
.image-div {
  height: 200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.product-checkbox-div {
  position: absolute;
  width: 16%;
}
.product-label-div {
  position: absolute;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
</style>